/* Davoreo — interacciones propias (vanilla, sin librerías) */
(function () {
  "use strict";

  // Evita que el script se ejecute dos veces (se carga global y por sección)
  if (window.__davoreoLoaded) return;
  window.__davoreoLoaded = true;

  var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function initReveals() {
    var els = document.querySelectorAll(".dv-reveal");
    if (!els.length) return;
    if (reduced || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("dv-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("dv-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  function initFaq() {
    var items = document.querySelectorAll(".dv-faq-item");
    if (!items.length) return;
    items.forEach(function (item) {
      var q = item.querySelector(".dv-faq-item__q");
      var a = item.querySelector(".dv-faq-item__a");
      if (!q || !a) return;
      q.addEventListener("click", function () {
        var open = item.classList.contains("is-open");
        item.classList.toggle("is-open");
        a.style.maxHeight = open ? null : a.scrollHeight + "px";
      });
    });
  }

  function initCountup() {
    var nums = document.querySelectorAll("[data-countup]");
    if (!nums.length || reduced || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-countup"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute("data-countup"));
        var suffix = el.getAttribute("data-suffix") || "";
        var dur = 1400, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target % 1 === 0 ? Math.round(target * eased) : (target * eased).toFixed(1)) + suffix;
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  function initGallery() {
    var galleries = document.querySelectorAll("[data-dv-gallery]");
    if (!galleries.length) return;
    galleries.forEach(function (gal) {
      var main = gal.querySelector(".dv-pdp__main img");
      var thumbs = gal.querySelectorAll(".dv-pdp__thumb");
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.getAttribute("data-full");
          if (full) main.src = full;
          thumbs.forEach(function (t) { t.classList.remove("is-active"); });
          thumb.classList.add("is-active");
        });
      });
    });
  }

  function getSelection() {
    var checked = document.querySelector("[data-dv-bundle] input:checked");
    if (checked) {
      return { qty: parseInt(checked.value, 10) || 1, code: checked.getAttribute("data-code") || "", variantId: checked.getAttribute("data-variant-id") || "" };
    }
    return { qty: 1, code: "" };
  }

  function initBundle() {
    var bundle = document.querySelector("[data-dv-bundle]");
    if (!bundle) return;
    // para pruebas: abrir la ficha con ?reset_oferta=1 reinicia la oferta de este navegador
    if (/[?&]reset_oferta=1/.test(location.search)) { try { localStorage.removeItem(OFFER_KEY); } catch (e) {} }
    var tiers = bundle.querySelectorAll(".dv-bundle__tier");
    function sync() {
      tiers.forEach(function (t) {
        var input = t.querySelector("input");
        t.classList.toggle("is-selected", input && input.checked);
      });
    }
    tiers.forEach(function (t) {
      var input = t.querySelector("input");
      if (input) input.addEventListener("change", sync);
    });
    sync();
    // oferta terminada para este visitante: la ficha enseña el precio por unidades sueltas
    if (offerExpired()) {
      var first = tiers[0] && tiers[0].querySelector(".dv-bundle__total");
      var base = first ? parseFloat(first.textContent.replace(/[^0-9,]/g, "").replace(",", ".")) : 0;
      if (base) {
        tiers.forEach(function (t) {
          var input = t.querySelector("input");
          var q = input ? parseInt(input.value, 10) || 1 : 1;
          if (q <= 1) return;
          var tot = t.querySelector(".dv-bundle__total");
          if (tot) tot.textContent = (base * q).toFixed(2).replace(".", ",") + " €";
          var unit = t.querySelector(".dv-bundle__unit");
          if (unit) unit.textContent = base.toFixed(2).replace(".", ",") + " €/ud";
          [".dv-bundle__old", ".dv-bundle__save"].forEach(function (c) {
            var e = t.querySelector(c); if (e) e.remove();
          });
          var bd = t.querySelector(".dv-bundle__badge");
          if (bd && /precio/i.test(bd.textContent)) bd.remove();
        });
      }
    }
  }

  function initAddToCart() {
    var pdp = document.querySelector("[data-dv-pdp]");
    if (!pdp) return;
    var id = pdp.getAttribute("data-variant-id");
    var buttons = document.querySelectorAll("[data-dv-add]");
    buttons.forEach(function (btn) {
      btn.addEventListener("click", function (e) {
        if (btn.disabled) return;
        e.preventDefault();
        var sel = getSelection();
        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = "Añadiendo…";
        var addReq = fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: sel.variantId || id, quantity: sel.variantId ? 1 : sel.qty })
        });
        addReq
          .then(function () {
            // aplicar el descuento del pack (si lo hay) sin salir de la página
            if (sel.code && !offerExpired()) {
              return fetch("/discount/" + encodeURIComponent(sel.code), { method: "GET" }).catch(function () {});
            }
          })
          .then(function () {
            btn.disabled = false;
            btn.textContent = original;
            if (window.dvOpenCart) { window.dvOpenCart(); }
            else { window.location.href = "/cart"; }
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = original;
          });
      });
    });
  }

  function initStickyBar() {
    var sticky = document.querySelector("[data-dv-sticky]");
    var buybox = document.querySelector("[data-dv-buybox]");
    if (!sticky || !buybox) return;
    sticky.removeAttribute("hidden");
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var belowBuybox = e.boundingClientRect.top < 0;
      sticky.classList.toggle("is-visible", !e.isIntersecting && belowBuybox);
    }, { threshold: 0 });
    io.observe(buybox);
  }

  function initDeliveryDate() {
    var els = document.querySelectorAll("[data-dv-delivery-date]");
    if (!els.length) return;
    var d = new Date();
    d.setDate(d.getDate() + 13);
    var txt;
    try {
      txt = d.toLocaleDateString("es-ES", { day: "numeric", month: "long" });
    } catch (e) {
      txt = d.getDate() + "/" + (d.getMonth() + 1);
    }
    els.forEach(function (el) { el.textContent = txt; });
  }

  /* ============ CARRITO (drawer) ============ */
  var cartEl;

  function money(cents) {
    return (cents / 100).toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  }

  function openCart() {
    if (!cartEl) return;
    loadCart();
    cartEl.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
  }
  function closeCart() {
    if (!cartEl) return;
    cartEl.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
  }

  /* ===== Packs por variante: el carrito siempre queda en el mejor precio ===== */
  var packCache = {};
  function getPackInfo(handle) {
    if (!packCache[handle]) {
      packCache[handle] = fetch("/products/" + handle + ".js")
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var vs = [];
          (p.variants || []).forEach(function (v) {
            var m = /^(\d+)\s*unidad/i.exec(v.title || "");
            if (m) vs.push({ id: v.id, units: parseInt(m[1], 10), price: v.price });
          });
          return vs.length > 1 ? vs : null;
        })
        .catch(function () { return null; });
    }
    return packCache[handle];
  }
  function bestCombo(total, packs) {
    var best = [0], from = [null], n;
    for (n = 1; n <= total; n++) {
      best[n] = Infinity;
      for (var i = 0; i < packs.length; i++) {
        var p = packs[i];
        if (p.units <= n && best[n - p.units] + p.price < best[n]) { best[n] = best[n - p.units] + p.price; from[n] = p; }
      }
    }
    var out = {}, k = total;
    while (k > 0 && from[k]) { out[from[k].id] = (out[from[k].id] || 0) + 1; k -= from[k].units; }
    return out;
  }
  function normalizeCart(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve(cart);
    var handles = [];
    cart.items.forEach(function (it) { if (it.handle && handles.indexOf(it.handle) < 0) handles.push(it.handle); });
    return Promise.all(handles.map(getPackInfo)).then(function (infos) {
      var updates = {}, changed = false;
      handles.forEach(function (h, i) {
        var packs = infos[i];
        if (!packs) return;
        var ids = packs.map(function (p) { return p.id; });
        var items = cart.items.filter(function (it) { return it.handle === h; });
        if (!items.every(function (it) { return ids.indexOf(it.variant_id) >= 0; })) return;
        var units = 0, current = {};
        items.forEach(function (it) {
          var p = packs.filter(function (x) { return x.id === it.variant_id; })[0];
          units += it.quantity * p.units;
          current[it.variant_id] = (current[it.variant_id] || 0) + it.quantity;
        });
        var usable = offerExpired() ? packs.filter(function (p) { return p.units === 1; }) : packs;
        if (!usable.length) return;
        var combo = bestCombo(units, usable);
        var same = ids.every(function (id) { return (combo[id] || 0) === (current[id] || 0); });
        if (same) return;
        ids.forEach(function (id) { updates[id] = combo[id] || 0; });
        changed = true;
      });
      if (!changed) return cart;
      return fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: updates })
      }).then(function (r) { return r.json(); });
    }).catch(function () { return cart; });
  }

  function loadCart() {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(normalizeCart)
      .then(renderCart)
      .catch(function () {});
  }

  function renderCart(cart) {
    if (!cartEl) return;
    var countEls = cartEl.querySelectorAll("[data-dv-cart-count]");
    countEls.forEach(function (e) { e.textContent = cart.item_count; });
    var tmr = cartEl.querySelector("[data-dv-cart-timer]");
    if (tmr) tmr.hidden = cart.item_count === 0;
    startOfferIfNeeded(cart.item_count);

    var items = cartEl.querySelector("[data-dv-cart-items]");
    var empty = cartEl.querySelector("[data-dv-cart-empty]");
    var foot = cartEl.querySelector("[data-dv-cart-foot]");
    if (cart.item_count === 0) {
      items.innerHTML = "";
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
    } else {
      if (empty) empty.hidden = true;
      if (foot) foot.hidden = false;
      items.innerHTML = cart.items.map(function (it) {
        var saving = it.total_discount > 0
          ? '<span class="dv-cart-item__save">Ahorras ' + money(it.total_discount) + "</span>" : "";
        var img = it.image
          ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="">'
          : "";
        return '<div class="dv-cart-item" data-key="' + it.key + '">' +
          '<div class="dv-cart-item__img">' + img + "</div>" +
          '<div class="dv-cart-item__body">' +
            '<div class="dv-cart-item__title">' + it.product_title + (it.variant_title && it.variant_title !== "1 unidad" && it.variant_title !== "Default Title" ? " · " + it.variant_title : "") + "</div>" +
            '<div class="dv-cart-item__qty">' +
              '<button type="button" data-dv-qty="dec" aria-label="Quitar uno">−</button>' +
              "<span>" + it.quantity + "</span>" +
              '<button type="button" data-dv-qty="inc" aria-label="Añadir uno">+</button>' +
            "</div>" +
          "</div>" +
          '<div class="dv-cart-item__right">' +
            '<div class="dv-cart-item__price">' + money(it.final_line_price) + "</div>" +
            (it.original_line_price > it.final_line_price ? '<s class="dv-cart-item__was">' + money(it.original_line_price) + "</s>" : "") +
            saving +
            '<button type="button" class="dv-cart-item__remove" data-dv-remove aria-label="Eliminar">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14"/></svg>' +
            "</button>" +
          "</div>" +
        "</div>";
      }).join("");
    }

    // barra de envío gratis
    var ship = cartEl.querySelector("[data-dv-cart-ship]");
    if (ship) {
      var threshold = parseInt(cartEl.getAttribute("data-freeship"), 10) || 0;
      if (threshold > 0) {
        var subtotal = cart.total_price;
        var pct = Math.min(100, Math.round((subtotal / threshold) * 100));
        var remaining = threshold - subtotal;
        ship.innerHTML =
          '<p class="dv-cart-ship__msg">' +
            (remaining > 0
              ? 'Te faltan <b>' + money(remaining) + "</b> para el <b>envío gratis</b> 🚚"
              : "¡Tienes <b>envío gratis</b>! 🎉") +
          "</p>" +
          '<div class="dv-cart-ship__bar"><span style="width:' + pct + '%"></span></div>';
      } else if (!cartEl.getAttribute("data-tier2-price")) {
        ship.innerHTML = "";
      } else {
        // aviso de packs: "añade uno más y ahorra" + código aplicado según cantidad
        var q = cart.item_count;
        var t2 = parseInt(cartEl.getAttribute("data-tier2-qty"), 10) || 2;
        var t3 = parseInt(cartEl.getAttribute("data-tier3-qty"), 10) || 3;
        var p2 = cartEl.getAttribute("data-tier2-price") || "";
        var p3 = cartEl.getAttribute("data-tier3-price") || "";
        var code = q >= t3 ? cartEl.getAttribute("data-tier3-code") : (q >= t2 ? cartEl.getAttribute("data-tier2-code") : "");
        if (code && code !== window.__dvCartCode && !offerExpired()) {
          window.__dvCartCode = code;
          fetch("/discount/" + encodeURIComponent(code), { method: "GET" }).catch(function () {});
        }
        if (q === 0 || offerExpired()) { ship.innerHTML = ""; }
        else {
          var msg, pct2;
          if (q < t2) { msg = "Añade <b>" + (t2 - q) + " más</b> y llévate <b>" + t2 + " por " + p2 + "</b> 🎁"; pct2 = Math.round(q / t3 * 100); }
          else if (q < t3) { msg = "Añade <b>" + (t3 - q) + " más</b> y llévate <b>" + t3 + " por " + p3 + "</b> 🎁"; pct2 = Math.round(q / t3 * 100); }
          else { msg = "¡Tienes el <b>pack de " + t3 + " por " + p3 + "</b>! 🎉"; pct2 = 100; }
          ship.innerHTML = '<p class="dv-cart-ship__msg">' + msg + "</p>" +
            '<div class="dv-cart-ship__bar"><span style="width:' + pct2 + '%"></span></div>';
        }
      }
    }

    // descuentos
    var disc = cartEl.querySelector("[data-dv-cart-discount]");
    if (disc) {
      if (cart.total_discount > 0) {
        var title = (cart.cart_level_discount_applications && cart.cart_level_discount_applications[0] && cart.cart_level_discount_applications[0].title) || "Descuento";
        disc.hidden = false;
        disc.innerHTML = '<span class="dv-cart__disc-tag">' + title + "</span><span>−" + money(cart.total_discount) + "</span>";
      } else { disc.hidden = true; }
    }

    var total = cartEl.querySelector("[data-dv-cart-total]");
    if (total) total.textContent = money(cart.total_price);
    var checkout = cartEl.querySelector("[data-dv-cart-checkout]");
    if (checkout) checkout.textContent = "Completar pedido · " + money(cart.total_price);
  }

  // "+" / "−" del cajón: suma o resta UNA unidad y el carrito se recoloca en el mejor pack
  function changeUnits(line, delta, current) {
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var item = cart.items[line - 1];
        if (!item) return renderCart(cart);
        return getPackInfo(item.handle).then(function (packs) {
          if (!packs) return changeQty(line, Math.max(0, current + delta));
          var ids = packs.map(function (p) { return p.id; });
          var units = 0;
          cart.items.forEach(function (it) {
            if (it.handle !== item.handle) return;
            var p = packs.filter(function (x) { return x.id === it.variant_id; })[0];
            if (p) units += it.quantity * p.units;
          });
          var target = Math.max(0, units + delta);
          var usable = offerExpired() ? packs.filter(function (p) { return p.units === 1; }) : packs;
          var combo = bestCombo(target, usable);
          var updates = {};
          ids.forEach(function (id) { updates[id] = combo[id] || 0; });
          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates: updates })
          }).then(function (r) { return r.json(); }).then(renderCart);
        });
      })
      .catch(function () {});
  }

  function changeQty(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(normalizeCart)
      .then(renderCart)
      .catch(function () {});
  }

  function initCart() {
    cartEl = document.querySelector("[data-dv-cart]");
    if (!cartEl) return;

    // abrir al pulsar el icono del carrito de la cabecera
    document.querySelectorAll('#cart-icon-bubble, a[href="/cart"], a[href$="/cart"]').forEach(function (link) {
      if (link.closest("[data-dv-cart]")) return;
      link.addEventListener("click", function (e) { e.preventDefault(); openCart(); });
    });

    // cerrar
    cartEl.querySelectorAll("[data-dv-cart-close]").forEach(function (b) {
      b.addEventListener("click", closeCart);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeCart(); });

    // qty y eliminar (delegación)
    cartEl.addEventListener("click", function (e) {
      var row = e.target.closest(".dv-cart-item");
      if (!row) return;
      var key = Array.prototype.indexOf.call(row.parentNode.children, row) + 1; // posición de la línea (la key cambia al aplicar descuentos)
      var qtySpan = row.querySelector(".dv-cart-item__qty span");
      var current = parseInt(qtySpan ? qtySpan.textContent : "1", 10) || 1;
      if (e.target.closest("[data-dv-remove]")) { changeQty(key, 0); return; }
      var qbtn = e.target.closest("[data-dv-qty]");
      if (qbtn) {
        var dir = qbtn.getAttribute("data-dv-qty");
        changeUnits(key, dir === "inc" ? 1 : -1, current);
      }
    });
  }

  function initCartReviews() {
    var box = document.querySelector("[data-dv-cart-rev]");
    if (!box) return;
    var items = box.querySelectorAll(".dv-cart-rev__item");
    if (items.length < 2) return;
    var secs = (parseInt(box.getAttribute("data-seconds"), 10) || 5) * 1000;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove("is-active");
      i = (i + 1) % items.length;
      items[i].classList.add("is-active");
    }, secs);
  }

  // expuesto para el flujo de añadir al carrito
  window.dvOpenCart = openCart;

  /* ===== Oferta del carrito: cuenta atrás que, al llegar a 0, se para y quita el descuento ===== */
  var OFFER_KEY = "dv_cart_offer";
  var OFFER_RESET_MS = 24 * 3600 * 1000; // la oferta vuelve a estar disponible a las 24 h
  function offerState() {
    try { return JSON.parse(localStorage.getItem(OFFER_KEY)) || null; } catch (e) { return null; }
  }
  function saveOffer(s) { try { localStorage.setItem(OFFER_KEY, JSON.stringify(s)); } catch (e) {} }
  function offerExpired() {
    var s = offerState();
    return !!(s && s.expired && Date.now() - s.expired < OFFER_RESET_MS);
  }
  function startOfferIfNeeded(itemCount) {
    if (!itemCount) return;
    var s = offerState();
    if (!s || (s.expired && Date.now() - s.expired >= OFFER_RESET_MS)) saveOffer({ start: Date.now(), expired: null });
  }
  function expireOffer() {
    var s = offerState();
    if (!s || s.expired) return;
    s.expired = Date.now();
    saveOffer(s);
    // los packs son variantes: al terminar la oferta, el carrito pasa a unidades sueltas (loadCart lo agrupa sin packs)
    loadCart();
  }

  function initUrgency() {
    function pad(n) { return String(n).padStart(2, "0"); }
    function fmt(diff) {
      var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000), s = Math.floor((diff % 60000) / 1000);
      return pad(h) + ":" + pad(m) + ":" + pad(s);
    }
    // contador sobre el pack: cuenta atrás hasta las 00:00 (y al pasar la medianoche, hasta la siguiente)
    var mid = document.querySelectorAll("[data-dv-midnight-out]");
    // contador del carrito
    var ct = document.querySelector("[data-dv-cart-timer]");
    var cout = ct && ct.querySelector("[data-dv-cart-timer-out]");
    var clabel = ct && ct.querySelector("span");
    var ctext = clabel ? clabel.textContent : "";
    var cms = ct ? (parseInt(ct.getAttribute("data-minutes"), 10) || 5) * 60000 : 0;
    var cexp = ct ? (ct.getAttribute("data-expired-text") || "La oferta de packs ha terminado") : "";
    function tick() {
      var now = new Date();
      if (mid.length) {
        var next = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
        var txt = fmt(next - now);
        mid.forEach(function (el) { el.textContent = txt; });
      }
      if (cout) {
        var st = offerState();
        if (offerExpired()) {
          ct.classList.add("is-expired");
          clabel.textContent = "⛔ " + cexp;
          cout.textContent = "";
        } else if (st && !st.expired) {
          ct.classList.remove("is-expired");
          clabel.textContent = ctext;
          var rem = cms - (Date.now() - st.start);
          if (rem <= 0) { cout.textContent = "00:00"; expireOffer(); }
          else cout.textContent = fmt(rem).slice(3);
        } else {
          ct.classList.remove("is-expired");
          clabel.textContent = ctext;
          cout.textContent = fmt(cms).slice(3);
        }
      }
    }
    if (!mid.length && !cout) return;
    tick();
    setInterval(tick, 1000);
  }

  function initCountdown() {
    var el = document.querySelector("[data-dv-countdown]");
    if (!el) return;
    var out = el.querySelector("[data-dv-countdown-timer]");
    if (!out) return;
    var minutes = parseInt(el.getAttribute("data-minutes"), 10) || 30;
    var endAttr = (el.getAttribute("data-end") || "").trim();
    var fixed = null;
    if (endAttr) {
      var d = new Date(endAttr);
      if (!isNaN(d.getTime()) && d.getTime() > Date.now()) fixed = d.getTime();
    }
    var target;
    if (fixed) {
      target = fixed;
    } else {
      var key = "dv_offer_end";
      var stored = parseInt(localStorage.getItem(key), 10);
      if (!stored || stored < Date.now()) {
        stored = Date.now() + minutes * 60000;
        try { localStorage.setItem(key, stored); } catch (e) {}
      }
      target = stored;
    }
    function pad(n) { return String(n).padStart(2, "0"); }
    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        if (fixed) { out.textContent = "00:00:00"; clearInterval(iv); return; }
        target = Date.now() + minutes * 60000;
        try { localStorage.setItem("dv_offer_end", target); } catch (e) {}
        diff = target - Date.now();
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      out.textContent = pad(h) + ":" + pad(m) + ":" + pad(s);
    }
    tick();
    var iv = setInterval(tick, 1000);
  }

  function initTracking() {
    var form = document.querySelector("[data-dv-track]");
    if (!form) return;
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var input = form.querySelector('input[name="tracking"]');
      var num = (input && input.value || "").trim();
      if (!num) return;
      var base = form.getAttribute("data-tracker") || "https://t.17track.net/es#nums=";
      window.open(base + encodeURIComponent(num), "_blank", "noopener");
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    if (window.__davoreoReady) return;
    window.__davoreoReady = true;
    initReveals();
    initFaq();
    initCountup();
    initGallery();
    initBundle();
    initAddToCart();
    initStickyBar();
    initDeliveryDate();
    initCart();
    initCartReviews();
    initTracking();
    initCountdown();
    initUrgency();
  });
})();
